var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M3.66984 3.08437L3.66797 4.49967V11.5025C3.66797 12.6991 4.63802 13.6691 5.83464 13.6691L11.5788 13.6693C11.3729 14.2518 10.8173 14.6691 10.1642 14.6691H5.83464C4.08573 14.6691 2.66797 13.2514 2.66797 11.5025V4.49967C2.66797 3.84587 3.08627 3.28976 3.66984 3.08437ZM11.8346 1.33301C12.6631 1.33301 13.3346 2.00458 13.3346 2.83301V11.4997C13.3346 12.3281 12.6631 12.9997 11.8346 12.9997H5.83464C5.00621 12.9997 4.33464 12.3281 4.33464 11.4997V2.83301C4.33464 2.00458 5.00621 1.33301 5.83464 1.33301H11.8346ZM11.8346 2.33301H5.83464C5.55849 2.33301 5.33464 2.55687 5.33464 2.83301V11.4997C5.33464 11.7758 5.55849 11.9997 5.83464 11.9997H11.8346C12.1108 11.9997 12.3346 11.7758 12.3346 11.4997V2.83301C12.3346 2.55687 12.1108 2.33301 11.8346 2.33301Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.25fbc2fca83fd07e79efb025c3d21354.svg";
export { ForwardRef as ReactComponent };